// Why a dispute was routed to manual review (mirrors recover/tasks.py
// gates). null → auto-approved or no decision recorded.
export const FLAG_REASON_META = {
  repeat_disputer: { label: "Repeat disputer", color: "red" },
  amount_above_limit: { label: "Above auto-approve limit", color: "orange" },
  below_win_likelihood: { label: "Low win-likelihood", color: "orange" },
  reason_code_always_manual: { label: "Per-category rule: always manual", color: "orange" },
  auto_approve_disabled: { label: "Manual mode", color: "default" }
}

// Fight / refund / accept recommendation from the backend decision engine
// (expected value + recovery economics). Tag colour + the one-line rationale per
// reason code the engine returns.
export const RECOMMENDATION_META = {
  fight: { label: "Fight", color: "green" },
  refund: { label: "Refund", color: "orange" },
  accept: { label: "Accept", color: "default" }
}

export const RECOMMENDATION_HINT = {
  positive_expected_value: "Good odds and recovery value. Submit your evidence.",
  no_history: "No track record yet, but you have a full evidence package. Worth contesting.",
  no_amount:
    "We could not read the amount, so we default to contesting. Double-check the amount before submitting.",
  very_low_odds: "Very low odds of winning. A refund avoids a likely loss and a dispute-ratio hit.",
  low_odds_repeat_disputer:
    "Poor odds and a repeat disputer. A refund cuts losses and protects your ratio.",
  below_value_floor: "Below your value floor. Not worth the effort to contest."
}
